import { render, staticRenderFns } from "./bootstyp.vue?vue&type=template&id=3b24a638&"
import script from "./bootstyp.vue?vue&type=script&lang=js&"
export * from "./bootstyp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports